// extracted by mini-css-extract-plugin
export default {"tupacGrid":"nm-z","tupacHeader":"om-z","tupacHeader2":"pm-z","tupacMenu":"qm-z","tupacMenu2":"rm-z","tupacMain":"sm-z","tupacMain2":"tm-z"};